import { BaseDataSourceOptions } from "../data-source/BaseDataSourceOptions"

/**
 * BaseConnectionOptions is set of connection options shared by all database types.
 *
 * @deprecated
 */
export type BaseConnectionOptions = BaseDataSourceOptions
